import * as ActionTypes from "constants/ActionTypes";
import LocalStorage from "utils/LocalStorage";
import { combineReducers } from "redux";

export function receivedUserInteraction(state = false, action) {
  switch (action.type) {
    case ActionTypes.RECEIVED_USER_INTERACTION:
      return true;
    case ActionTypes.RESET_INITIAL_STATE:
      return false;
    default:
      return state;
  }
}

export function userNotifier(
  state = {
    message: "",
    openNotifier: false,
    title: "",
  },
  action,
) {
  switch (action.type) {
    case ActionTypes.CLOSE_USER_NOTIFIER:
      return {
        ...state,
        message: "",
        openNotifier: false,
        title: "",
      };
    case ActionTypes.SHOW_USER_NOTIFIER:
      return {
        ...state,
        openNotifier: true,
        title: action.title,
        message: action.message,
      };
    default:
      return state;
  }
}

export function userReportedStory(
  state = {
    reported: false,
    storyId: null,
  },
  action,
) {
  switch (action.type) {
    case ActionTypes.USER_INTERACTION_REPORT_ABUSE: {
      LocalStorage.set("reported-story", action.storyId);
      return {
        ...state,
        reported: true,
        storyId: action.storyId,
      };
    }
    default:
      return state;
  }
}

export function userSharedStory(
  state = {
    shareTypes: [],
  },
  action,
) {
  switch (action.type) {
    case ActionTypes.USER_SHARED_STORY: {
      return {
        ...state,
        shareTypes: [...state.shareTypes, action.shareType],
      };
    }
    default:
      return state;
  }
}

export function userInteractionInitiatedPlayback(state = false, action) {
  switch (action.type) {
    case ActionTypes.USER_INTERACTION_INITIATED_PLAYBACK:
      return true;
    default:
      return state;
  }
}

export default combineReducers({
  receivedUserInteraction,
  userInteractionInitiatedPlayback,
  userNotifier,
  userReportedStory,
  userSharedStory,
});
